import { Form, Input, Spin } from "antd";
import LoadableButton from "../../../components/buttons/LoadableButton";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { AddDepositWithdrawRequestApi, VerifyDepositWithdrawOtpApi } from "../../../api/request/client";
import moment from "moment";

export default function DepositWithdraw({ transactionType, title, description }) {
    const { id } = useParams();
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [isResendLoading, setIsResendLoading] = useState(false);
    const [otpStep, setOtpStep] = useState(false);
    const [timer, setTimer] = useState(120);

    const handleFormSubmit = async (values, isResend = false) => {
        isResend ? setIsResendLoading(true) : setIsLoading(true);
        try {
            if (!otpStep || isResend) {
                const payload = { amount: Number(values.amount) };
                const { data } = await AddDepositWithdrawRequestApi(payload);
                if (data?.success) {
                    toast.success(data?.message);
                    setOtpStep(true);
                    setTimer(110);
                }
            } else {
                const params = {
                    userId: id,
                    otp: values.otp,
                    amount: Number(values.amount),
                    transactionType: transactionType,
                    Remark: values.remark,
                };
                const { data } = await VerifyDepositWithdrawOtpApi(params);
                if (data?.success) {
                    toast.success(data?.message);
                    form.resetFields();
                    setOtpStep(false);
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setIsResendLoading(false);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (otpStep) {
            const interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [otpStep, timer]);


    return (
        <div className="w-full max-w-md mx-auto mt-14">
            <div className="mb-8 text-center">
                <h2 className="text-2xl text-[#1E232CC7] font-bold">{title}</h2>
                <p className="text-[#1E232CC7]">{description}</p>
            </div>

            <Form form={form} onFinish={handleFormSubmit} autoComplete="off" className="border border-light rounded-lg p-8" >
                <div className="flex flex-col gap-4">
                    <div className="input-white">
                        <label className="text-description text-[#2F2B3DCC] font-medium"> Amount In USD </label>
                        <Form.Item name="amount" rules={[{ required: true, message: "Please enter amount." }]} >
                            <Input type="number" placeholder="Enter Amount" className="mt-1 w-full ps-4 py-2" disabled={otpStep}
                                prefix={<span className="text-[#2F2B3DCC]">$</span>} />
                        </Form.Item>
                    </div>
                    <div className="input-white">
                        <label className="text-description text-[#2F2B3DCC] font-medium">Remark</label>
                        <Form.Item name="remark" >
                            <Input placeholder="Enter any remark" className="mt-1 w-full ps-4 py-2" disabled={otpStep} />
                        </Form.Item>
                    </div>
                </div>

                {otpStep && (
                    <div className="input-white mt-10">
                        <label className="text-description text-[#2F2B3DCC] font-medium">Enter OTP</label>
                        <div className="w-full text-sm py-1">
                            <div className="relative">
                                <Form.Item name="otp" rules={[{ required: true, message: "Please enter OTP." }]} >
                                    <Input.OTP style={{ width: "100%" }} maxLength={6} />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="my-6 flex justify-center">
                            {timer == 0 ? (
                                <button type="button" onClick={() => handleFormSubmit(form.getFieldsValue(), true)} className="text-sm" >
                                    <span className="text-black font-normal"> Didn't receive it? </span>
                                    <span className="underline primary font-bold ms-1"> {isResendLoading ? <Spin size="small" /> : 'Resend OTP'} </span>
                                </button>
                            ) : (
                                <p>Resend OTP in  <span className="primary font-bold">{moment.utc(timer * 1000).format('mm:ss')}</span></p>
                            )}
                        </div>
                    </div>
                )
                }

                <div className="flex justify-center items-center gap-5 mt-8">
                    <LoadableButton
                        className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500"
                        type="submit"
                        lable={otpStep ? "Verify" : "Proceed"}
                        loadingLable={isLoading ? otpStep ? "Verifying..." : "Sending OTP..." : ''}
                        isLoading={isLoading}
                        disabled={isLoading || isResendLoading}
                    />
                </div>
            </Form >
        </div >
    );
}
